module.exports = __webpack_public_path__ + "static/media/face-6.61a3d859.jpg";